<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title flex_between">
      <span>处方详情</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>

    <div style="padding: 20px">
      <div class="container">
        <div class="inbobox">
          <div class="inboitem">
            <div>
              <span class="infotitle">用户昵称：</span>
              <span>{{ detail.nick_name }}</span>
            </div>
            <div style="margin: 12px 0">
              <span class="infotitle">性别：</span>
              <span v-if="detail.user_sex == 1">男</span>
              <span v-if="detail.user_sex == 2">女</span>
              <span v-if="detail.user_sex == 0">未知</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{ detail.user_phone }}</span>
            </div>
          </div>
          <div class="inboitem">
            <div style="display: flex">
              <div>
                <span class="infotitle">医生姓名：</span>
                <span
                  @click="showDocMsg(detail.doctor_id)"
                  style="cursor: pointer"
                  >{{ detail.doctor_name }}</span
                >
              </div>
              <div style="margin: 0 50px">
                <span>性别：</span>
                <span v-if="detail.doctor_sex == 1">男</span>
                <span v-if="detail.doctor_sex == 2">女</span>
              </div>
              <div>
                <span>手机号：</span>
                <span>{{ detail.doctor_phone }}</span>
              </div>
            </div>

            <div style="margin: 12px 0">
              <span class="infotitle">职称：</span>
              <span>{{ detail.title }}</span>
            </div>
            <div>
              <span class="infotitle">科室：</span>
              <span>{{ detail.department_name }}</span>
            </div>
          </div>
        </div>
        <div style="border-bottom: 8px solid #f3f3f3; margin-bottom: 30px">
          <span>
            <span>开方时间：</span>
            <span>{{ detail.create_time }}</span>
          </span>
          <span style="margin: 0 50px">
            <span>处方状态：</span>
            <span>
              <!-- <span v-if="detail.status==1">待取药</span>
              <span v-if="detail.status==2">待审方</span>
              <span v-if="detail.status==3">已通过</span>
              <span v-if="detail.status==4">已抓药</span>
              <span v-if="detail.status==5">过期未取药</span>
              <span v-if="detail.status==6">审方不通过</span> -->

              <span v-if="detail.status == 1">待取药</span>
              <span v-if="detail.status == 2">待审方</span>
              <span v-if="detail.status == 3">已通过</span>
              <span v-if="detail.status == 4">已抓药</span>
              <span v-if="detail.status == 5">过期未取药</span>
              <span v-if="detail.status == 6">审方不通过</span>
              <span v-if="detail.status == 7">已失效</span>
              <span v-if="detail.status == 8">已失效</span>
            </span>
          </span>
          <span>
            <span>处方号：</span>
            <span>{{ detail.pre_id }}</span>
          </span>
        </div>
        <div class="title">诊断</div>
        <div style="margin-bottom: 30px">
          <div>
            <span>患者：</span>
            <span>{{ detail.user_name }}</span>
            <span style="margin: 0 40px">{{
              detail.patient_sex == 1 ? "男" : "女"
            }}</span>
            <span>{{ detail.age }}</span>
          </div>
          <div style="margin: 14px 0">
            <span>主诉：</span>
            <span>{{ detail.chief_complaint }}</span>
          </div>
          <div>
            <span>诊断：</span>
            <span>{{ detail.diagnosis }}</span>
          </div>
        </div>
        <div class="title">开方</div>
        <div>
          <span>{{ detail.drug_type_name }}</span>

          <span style="margin-left: 40px">{{ detail.hospital_name }}</span>
        </div>
        <div
          style="
            font-size: 22px;
            color: #000000;
            font-weight: 600;
            margin: 20px 0;
          "
        >
          Rp：
        </div>
        <!-- 药品 -->
        <div class="itembox">
          <div class="item" v-for="(item, index) in drugs_list" :key="index">
            <span style="white-space: nowrap"
              >{{ item.generic_name
              }}{{ item.is_national_standard | nationalStandardText }}</span
            >

            <span style="margin-left: 10px">
              <template v-if="item.is_national_standard == 1">
                <span>{{ item.national_standard_level }}g</span>
                <span
                  v-if="
                    item.is_national_standard == 1 &&
                    detail.is_sure_national_standard == 1 &&
                    item.dosage_unit == 2
                  "
                  >(原{{ item.item_use_level }}g)</span
                >
              </template>
              <template v-else>
                <span>{{ item.item_use_level }}g</span>
              </template>

              <span v-if="item.dosage_unit != 2"
                >({{ item.num }}{{ item.dosage_unit_name }})</span
              >

              <span v-if="item.requirement">({{ item.requirement }})</span>
            </span>

            <!-- <span style="white-space: nowrap; margin-left: 10px">
              <template v-if="item.is_national_standard == 1">
                <span>{{ item.national_standard_level }}g</span>
                <span v-if="item.is_national_standard == 1"
                  >(转前{{ item.item_use_level }}g)</span
                >
              </template>
              <template v-else>
                <span>{{ item.item_use_level }}g</span>
              </template>
              <span v-if="item.requirement">({{ item.requirement }})</span>
            </span> -->
          </div>
        </div>
        <!-- 膏方 -->
        <div class="itembox">
          <div class="item" v-for="(item, index) in oil_list" :key="index">
            <span>{{ item.oil_name }}</span>
            <span>
              <span>{{ item.item_use_level }}{{ item.oil_unit }}</span>
            </span>
          </div>
        </div>
        <div
          style="color: #747981; margin-bottom: 30px"
          v-if="drugs_list.length > 0"
        >
          <span v-if="detail.use_type == 1">内服</span>
          <span v-if="detail.use_type == 2">外用</span>
          <span style="margin-left: 10px">共</span>
          <span style="color:#70a06c;font-weight;600">{{
            detail.total_num
          }}</span>
          <span
            >剂，每{{ detail.days == 1 ? "" : detail.days }}日1剂，每剂</span
          >
          <span
            style="color:#70a06c;font-weight;600"
            v-if="detail.use_type == 1"
            >分{{ detail.day_num }}次服用</span
          >
          <span
            style="color:#70a06c;font-weight;600"
            v-if="detail.use_type == 2"
            >分{{ detail.day_num }}次使用</span
          >
        </div>
        <div class="title">医嘱</div>
        <div style="margin-bottom: 30px">
          <div>
            <span>用法：</span>
            <span>{{ detail.use_method }}</span>
          </div>
          <div style="margin: 14px 0">
            <span>禁忌：</span>
            <span>{{ detail.taboo }}</span>
          </div>
          <div>
            <span>特殊说明：</span>
            <span>{{ detail.doctor_advice }}</span>
          </div>
        </div>

        <div class="title">费用明细</div>
        <div style="margin-bottom: 30px; color: #000">
          <div>
            <span
              style="
                display: inline-block;
                width: 210px;
                text-align: right;
                margin-right: 20px;
              "
              >药品金额：</span
            >
            <span>{{ detail.drug_price }}</span>
          </div>
          <div style="margin: 14px 0">
            <span
              style="
                display: inline-block;
                width: 210px;
                text-align: right;
                margin-right: 20px;
              "
              v-if="detail.gold_join"
              >诊金（患者端附加到药品金额）：</span
            >
            <span
              v-else
              style="
                display: inline-block;
                width: 210px;
                text-align: right;
                margin-right: 20px;
              "
              >诊金：</span
            >
            <span>{{ detail.consulting_gold }}</span>
          </div>
          <div>
            <span
              style="
                display: inline-block;
                width: 210px;
                text-align: right;
                margin-right: 20px;
              "
              >总计：</span
            >
            <span>{{ detail.total_price }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      detail: {},
      drugs_list: [],
      oil_list: [],
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
  },
  filters: {
    nationalStandardText(val) {
      switch (Number(val)) {
        case 1:
          return "(新)";
        case 0:
          return "";
      }
    },
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取详情
    getDetail() {
      let pre_id = this.$route.query.pre_id;
      this.axios
        .post("platform/prescription/prescriptionItem", { pre_id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
            this.drugs_list = res.data.info.item_list;
            this.oil_list = res.data.info.oil_item_list;
            this.detail.create_time = moment
              .unix(this.detail.create_time)
              .format("YYYY-MM-DD HH:mm");
          }
        });
    },

    back() {
      history.back();
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
}
.inbobox {
  display: flex;
  .inboitem {
    padding: 14px 50px 14px 20px;
    box-sizing: border-box;
    margin-bottom: 12px;
    margin-right: 20px;
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    .infotitle {
      width: 90px;
      display: inline-block;
    }
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 14px;
}
.itembox {
  display: flex;
  color: #000;
  flex-wrap: wrap;
  .item {
    width: 180px;
    display: flex;
    justify-content: space-between;
    margin-right: 40px;
    position: relative;
    margin-bottom: 22px;
  }
  .item::before {
    content: "";
    position: absolute;
    height: 12px;
    width: 1px;
    background: #d7d7d7;
    left: 200px;
    top: 4px;
  }
}
</style>
